import LimitationUserRow from './LimitationUserRow';

export default LimitationUserRow;
